import { ScopesOfWork } from "../scopeOfWork";
import { TestEvents } from "../testEvents";

export function OwnedView() {
  return (
    <ul>
      <li className="mb-3">
        <ScopesOfWork filters={{ owned: true }} />
      </li>
      <li className="mb-3">
        <TestEvents filters={{ owned: true }} />
      </li>
    </ul>
  );
}
